import { z } from 'zod';
const SIGNATURE_BASE64_MAX_LENGTH = 400_000;
export const saveSignatureSchema = z.object({
    png: z.string().min(1).max(SIGNATURE_BASE64_MAX_LENGTH).base64(),
});
export const signatureOutputSchema = z.object({
    image: z.string().nullable(),
    updatedAt: z.date().nullable(),
});
export const saveSignatureOutputSchema = z.object({ updatedAt: z.date() });
export const signatureStatusOutputSchema = z.object({ hasSignature: z.boolean() });
//# sourceMappingURL=signature.js.map